import React from 'react';
import './OnlineCourses.css';

const OnlineCourses = () => {
  return (
    <section
      className="online-courses"
      id="courses"
      style={{
        backgroundImage: `url('${process.env.PUBLIC_URL}/assets/images/hero-bottom.webp')`
      }}
    >
      <div className="online-courses__container">
        {/* Header Block */}
        <div className="online-courses__header">
          <h4 className="online-courses__subtitle">
            <svg aria-hidden="true" className="online-courses__subtitle-icon" viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z" />
            </svg>
            <span>Online Quran Courses</span>
          </h4>

          <h2 className="online-courses__title">
            Our Online Quran Courses for Everyone!
          </h2>

          <p className="online-courses__description">
            We are proud to offer online Quran classes in a private setting, specifically designed for you or your kid. Whatever brought you here- a child just starting, or your own search for Quran classes online- we have a course designed for exactly that starting point. We have a 3-day free trial available on every Quran course we offer, which means we are confident in what we deliver.
          </p>
        </div>

        {/* Content Columns */}
        <div className="online-courses__grid">
          {/* Left Column: Course 1 & 2 */}
          <div className="online-courses__col">
            {/* Course 1 */}
            <div className="online-courses__card">
              <div className="online-courses__card-header">
                <svg aria-hidden="true" className="online-courses__card-icon" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
                  <path d="M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z" />
                </svg>
                <h3 className="online-courses__card-title">Noorani Qaida Course</h3>
              </div>
              <p className="online-courses__card-text">
                Start from the very basics and practice how to pronounce and connect the Arabic letters for accurate Quran reading.
              </p>
              <a href="/noorani-qaida-course/" className="online-courses__card-btn" style={{ textDecoration: 'none' }}>
                Start Learning Qaida Now
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="online-courses__btn-icon">
                  <path d="M16.01 11H4v2h12.01v3L20 12l-3.99-4v3z" />
                </svg>
              </a>
            </div>

            {/* Course 2 */}
            <div className="online-courses__card">
              <div className="online-courses__card-header">
                <svg aria-hidden="true" className="online-courses__card-icon" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
                  <path d="M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z" />
                </svg>
                <h3 className="online-courses__card-title">Learn Quran With Tajweed</h3>
              </div>
              <p className="online-courses__card-text">
                Quran reading with Tajweed rules that govern correct pronunciation and articulation, so recitation isn't just fluent; it's accurate.
              </p>
              <a href="/online-tajweed-classes-tajweed-course/" className="online-courses__card-btn" style={{ textDecoration: 'none' }}>
                Enroll In Tajweed Classes
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="online-courses__btn-icon">
                  <path d="M16.01 11H4v2h12.01v3L20 12l-3.99-4v3z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Middle Column: Arched Image */}
          <div className="online-courses__img-col">
            <div className="online-courses__img-arched-wrapper">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/img-1-01-1646x2048.webp`}
                alt="Male and Female Tutors for online Quran classes"
                className="online-courses__arched-img"
              />
            </div>
          </div>

          {/* Right Column: Course 3 & 4 */}
          <div className="online-courses__col">
            {/* Course 3 */}
            <div className="online-courses__card">
              <div className="online-courses__card-header">
                <svg aria-hidden="true" className="online-courses__card-icon" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
                  <path d="M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z" />
                </svg>
                <h3 className="online-courses__card-title">Quran Reading Classes</h3>
              </div>
              <p className="online-courses__card-text">
                Start from recognizing Arabic letters and build toward confident, independent reading, one step at a time.
              </p>
              <a href="/quran-reading-classes-online-for-kids-and-adults/" className="online-courses__card-btn" style={{ textDecoration: 'none' }}>
                Join Our Reading Program
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="online-courses__btn-icon">
                  <path d="M16.01 11H4v2h12.01v3L20 12l-3.99-4v3z" />
                </svg>
              </a>
            </div>

            {/* Course 4 */}
            <div className="online-courses__card">
              <div className="online-courses__card-header">
                <svg aria-hidden="true" className="online-courses__card-icon" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
                  <path d="M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z" />
                </svg>
                <h3 className="online-courses__card-title">Quran Memorization (Hifz)</h3>
              </div>
              <p className="online-courses__card-text">
                A steady, structured approach to Quran memorization, with regular revision and a pace set by the student, not a fixed calendar.
              </p>
              <a href="/quran-memorization-classes-course/" className="online-courses__card-btn" style={{ textDecoration: 'none' }}>
                Start Memorizing With Experts
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="online-courses__btn-icon">
                  <path d="M16.01 11H4v2h12.01v3L20 12l-3.99-4v3z" />
                </svg>
              </a>
            </div>

            {/* Course 5 */}
            <div className="online-courses__card">
              <div className="online-courses__card-header">
                <svg aria-hidden="true" className="online-courses__card-icon" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
                  <path d="M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z" />
                </svg>
                <h3 className="online-courses__card-title">Quran Translation Classes</h3>
              </div>
              <p className="online-courses__card-text">
                Go beyond recitation into meaning, with verse-by-verse translation explained in plain language and real context.
              </p>
              <a href="/quran-translation-classes/" className="online-courses__card-btn" style={{ textDecoration: 'none' }}>
                Explore Translation Classes
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="online-courses__btn-icon">
                  <path d="M16.01 11H4v2h12.01v3L20 12l-3.99-4v3z" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OnlineCourses;

